import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Menu, Dropdown, Tooltip, Modal } from 'antd';
import styles from "./scss/voicemailList.module.scss";
import { URButton } from "../../../shared/widgets/button";
//import VoiceMailAudioSidebar from "../callsWidgets/voiceMailAudioSidebar";
import { initiateCall } from "../../../base/callService/callService";
import PopoverModule from "../callsWidgets/PopoverModule/PopoverModule";
import WaveFormLeft from "../callsWidgets/playerWaveForm/WaveformLeftSide";
import { DeleteAllVoicemails, deleteVoicemail, getVoiceMailLogs,statusVoiceMail} from "../../../base/callService/callsApiService";
import {
  callActionChanges,
  detailStore, getVmTranscript, handlingKeyMovement, searchHandler, searchHighlight,
  secondsToHMSConverter,
  selectList, timeStampConverter, toastInformation
}
  from "../../../base/callService/common";
import { URChatLeftSkeleton } from "../../../shared/skeletonLoading/chatLeftSkeleton";
import { URCheckBoxCall } from "../../../shared/widgets/checkBoxForCall/callCheckBox";
//import WaveFormVoicemail from "../callsWidgets/playerWaveForm/WaveFormAudio";
import groovyWalkAnimation from "../../../styles/images/chat blank state loading.json";
import ContactLoader from "../../../styles/images/Lottie Animation.json";
import Lottie from "lottie-react";
import voicemailblank from "../../../styles/images/empty_states/empty-voicemail.svg";
import NoContent from "../../../shared/widgets/noContent";
import { initialStateModel } from "../../../models/model";
import store from "../../../context/store/store";
import { storeChatWindow } from "../../../base/callService/store_mining";
import { Types } from "../../../context/action/action";
import { callSDK } from "unifiedring-sdk";

type voiceMailProps = {
  backEventTrigger: (data: any) => void;
};

type voiceMailState = {
  isClear: boolean;
  isModalVisible: boolean;
  isDeleteAll: boolean;
  deleteArr: Array<any>;
  modalStatus: string;
  miniPlayer: boolean;
  isKeyPressed: boolean;
};

export default function VoiceMailLists({backEventTrigger}:voiceMailProps) {

  const [GetVoiceMail,setVoiceMail] = useState<voiceMailState>({
    isClear:false, isModalVisible:false,
    isDeleteAll:false,deleteArr:[],modalStatus:'',miniPlayer:false,isKeyPressed:false
  });

  
    const {callReducer }: initialStateModel = useSelector((state: initialStateModel) => state);
  let { logs,isLogLoading,logsInput, particularLog,totalVoicemails} = callReducer;
  //let coloryy = userStatusColor('Available', 'small');

  const voiceMailBackPress = () => { backEventTrigger('callList'); };

  const deleteVoiceMail=()=> {
    setVoiceMail({...GetVoiceMail,isClear:true,deleteArr:[]});};

  const canceldeleteVoiceMail=()=> {
    closeAll();  };

  const deleteCheckBox=(Vm_uuid:any,isConfirm?:boolean)=>{
    let { deleteArr } = GetVoiceMail;
    setVoiceMail({ ...GetVoiceMail, deleteArr: selectList(deleteArr, Vm_uuid), isDeleteAll: false });

   isConfirm&& setVoiceMail({...GetVoiceMail,isModalVisible:true,modalStatus:'single'});
  };

  const deleteALL=(e:any)=>{
    if(e.target.checked) {
      let deleteArr =  logs?.map((val:any)=>{ return val.Vm_uuid;});
      setVoiceMail({...GetVoiceMail,isDeleteAll:true,deleteArr:deleteArr});
    }
    else {
      if(!e.target.checked){
        setVoiceMail({
          ...GetVoiceMail, modalStatus: '', deleteArr: [], isDeleteAll: false
        });      }
    }
  };




  const detailVoiceMail = (logDetail:any)=>{
    store.dispatch({
      type: Types.VOICE_MAIL_LIST,
      payload: {
        voicemailTrans: ""
      }
    });
    let {isProfileView}=store.getState().updatedCallList||{};

    if(isProfileView===true){storeChatWindow(logDetail)}

     detailStore(logDetail);
     };

  const handleScroll = (e: any) => {


    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if (bottom) {

      getVoiceMailLogs(logsInput.offset+25,logsInput.search);

    }
  };
 
  const updateFlagVoiceMail =(list:any)=>{ statusVoiceMail(list); };
  
  const deleteByCheck = (options: string) => {
    if (GetVoiceMail.deleteArr.length === 0) {
      toastInformation("select any member", "success");
    }
    else {
      setVoiceMail({...GetVoiceMail,isModalVisible:true,modalStatus:options});
    }
  };

  const handleOk = () => {

      GetVoiceMail.isDeleteAll?DeleteAllVoicemails():deleteVoicemail(GetVoiceMail.deleteArr);

      closeAll();
    
  };

  const handleCancel=() => {
    setVoiceMail({...GetVoiceMail,isModalVisible: false,modalStatus:''});
  };
  
  const playAudio =()=>{
    // setVoiceMail({...GetVoiceMail,miniPlayer:true});
  };

  const closeAll=()=>{
    setVoiceMail({
      ...GetVoiceMail, isModalVisible: false,
      isClear: false, modalStatus: '', deleteArr: [], isDeleteAll: false
    });

  };

  let searchedResults:any = searchHandler(logs,logsInput?.search?.toLowerCase()) || [];

  const activeContact = useRef(null);
  const keyHandler = (ev: any) => {
    let startFocus:any=activeContact.current;
      if ((ev.keyCode === 38 || ev.keyCode === 40)&&startFocus!==null) {
        let movingPosition:any = 0;
        if (particularLog) {  
           movingPosition = handlingKeyMovement(ev);
          startFocus.scrollIntoViewIfNeeded();
  
          if (!movingPosition && movingPosition === undefined) movingPosition = 0;
          let { logs} = store.getState().callReducer||{};
          detailVoiceMail(logs[movingPosition]);

  
        }
      }
    };
  
  useEffect(() => {
    window.addEventListener("keyup", (e: KeyboardEvent) => keyHandler(e));
    return () => {
      window.removeEventListener("keyup", keyHandler );
    };
  }, []);
  var len = Math.round((searchedResults?.length / 8));
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  return (
    <>
      <div className={styles.voiceMaillistmain}>
        {/* <div className={styles.rightbartop}>
          <div className={styles.lefts} title="Back" onClick={voiceMailBackPress}>
            <span className={styles.backArrow}></span> Voicemails
          </div>
          <div className={styles.rights}>
            {totalVoicemails}
          </div>
        </div> */}
        <div className={styles.clearLogLeft}>
          <div className={styles.checkBoxArea}>
            {GetVoiceMail.isClear && <URCheckBoxCall  onChange={(e:any)=>deleteALL(e)}
              checked={GetVoiceMail.isDeleteAll}/>}
          </div>
          <div className={styles.btnSec}>
            {GetVoiceMail.deleteArr.length > 0 &&GetVoiceMail.isClear&&
              <URButton className='urButton buttonTransparent fordeleting'
                name={GetVoiceMail.isDeleteAll ? 'DeleteAll' : 'Delete'}
                onClick={() => deleteByCheck(GetVoiceMail.isDeleteAll ? 'DeleteAll' : 'Delete')} />}
            {GetVoiceMail.isClear &&
              <URButton onClick={canceldeleteVoiceMail} className='urButton buttonTransparent' name='Cancel' />}
       
            { searchedResults?.length>1
             && !GetVoiceMail.isClear? <URButton onClick={deleteVoiceMail} className='urButton buttonTransparent'
                name='Clear Log'/> : null}
          </div>
        </div>

        <div className={`${styles.scrolllayerleft} ${"scrollerhover"}`} onScroll={handleScroll}>
          <div className={styles.rightbarbottom}>
            {searchedResults && searchedResults?.length > 0 ? <>
            
              {searchedResults?.map((list: any, index: any) => {
                let message: any = searchHighlight(list, logsInput?.search);
                  
                return < div key={index} onClick={() => { GetVoiceMail?.isClear ? deleteCheckBox(list?.Vm_uuid, false) : detailVoiceMail(list);
                }}
                 >
                  <div className={particularLog?.Vm_uuid === list.Vm_uuid ?
                    (`${styles.profilelists} ${styles.active}`) :
                    (list.ReadFlag === "0" ? `${styles.profilelists} ${styles.unreadProfile}` :
                      `${styles.profilelists}`)}   ref={(particularLog?.Vm_uuid === list?.Vm_uuid)?activeContact:null}>
                    
                    <div className={`${styles.clearSelect} ${styles.clearSelected}`}>
                      {GetVoiceMail.isClear && <URCheckBoxCall
                        checked={GetVoiceMail.deleteArr.includes(list.Vm_uuid) ? true : false} />}
                    </div>
                    <div title="View contact details">
                      <PopoverModule popOverValues={list} randomColor={random_color[index]} value={false} />
                      </div>
                    <div className={styles.vmsideDetails}>
                      <div className={styles.frow}>
                        {(logsInput.search !== ""&&message.key==='name') ?
                          ( <h4>{(message?.middleMsg !== "") ? (<>{message?.firstMsg}
                            <b className={styles.highlight}>{message?.middleMsg}</b>{message?.lastMsg}</>) :
                            (<>{list?.caller_id}</>)}</h4>) :
                          (<h4>{list?.caller_id}</h4>) }
                        
                        <p>
                          <span onClick={playAudio} className="icon_Recordcalls"> </span>
                          {secondsToHMSConverter(parseInt(list?.wav_duration))}</p>
                        {/* <p><VoiceMailAudioSidebar  url={list.geturl}/></p> */}
                      </div>
                      {GetVoiceMail.miniPlayer && <WaveFormLeft voiceValues={list} />}
                      <div className={styles.secondrow}>
                          
                        {(logsInput?.search !== ""&&message.key==='date') ?
                          ( <span>{ (message?.middleMsg !== "") ?(<>{message?.firstMsg}
                            <b className={styles.highlight}>{message?.middleMsg}</b>
                            {message?.lastMsg}</>):
                            (<>{timeStampConverter(list?.created_date,'list')}</>)}</span>
                          ) :
                          (<span>{timeStampConverter(list?.created_date,'list')}</span>)
                        }
                        <div className={`${list.ReadFlag === "0" ? styles.unreadDot : ''}`}></div>
                      </div>
                    </div>
                 {!GetVoiceMail.isClear&& <div className={styles.hoverdiv}>
                      <ul>
                        <li><Tooltip placement="top" title="Call"><span className={styles.iconCall}
                          onClick={() => initiateCall(list.ext, 'audio')}></span></Tooltip></li>
                        <li>
                          <Dropdown overlay={
                            <Menu className={styles.markunread}>
                              <Menu.Item key="0" onClick={() => updateFlagVoiceMail(list)}>{list.ReadFlag === "0" ?
                                <>Mark as Read</> : <>Mark as Unread</>}</Menu.Item>
                              {/* <Menu.Item>Mark as Unread</Menu.Item> */}
                              <Menu.Item onClick={() => deleteCheckBox(list.Vm_uuid,true)}>Delete</Menu.Item>
                            </Menu>
                          } placement="bottomRight" trigger={['click']}>
                            <Tooltip placement="top" title="More"><span className="icon_overflow-H"></span></Tooltip>
                          </Dropdown>
                        </li>
                      </ul>
                    </div>}
                  </div>
                </div>;
              })
              }
              {isLogLoading && <div className="svgLoadinglist"><Lottie className="svgLoading"
                animationData={ContactLoader} /></div>}</>
              :
              (!isLogLoading) ? 
  
              
              <NoContent image={voicemailblank}
              title={'No Voicemails yet'}
              description={''} />
              
              :
                <>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]
                    ?.map((item: any, index: any) => (
                      <URChatLeftSkeleton key={index} />
                    ))}
                </>
              
            }
          </div>
        </div>
      </div>
      <Modal title={GetVoiceMail.modalStatus==='DeleteAll'? "Delete All vociemails?":"Delete vociemail?"}
        centered
        visible={GetVoiceMail.isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        { GetVoiceMail.modalStatus==='DeleteAll' ?
          "Are you sure you want to permanently delete all voicemails?"
          :  "Are you sure you want to permanently delete the selected voicemail?"}
      </Modal>
    </>
  );
};









